import "./PaginationComponent.scss";
import PropTypes from "prop-types";

/**
 * @function PaginationComponent Component that handles pagination
 * @param currentPage number that indicates the current page
 * @param pages number that indicates the quantity of pages
 * @returns {JSX.Element}
*/
const PaginationComponent = ({ currentPage, totalPages, paginate }) => {

    const pageNumbers = [];
    const indietroDisabled = currentPage === 1;
    const avantiDisabled = currentPage === totalPages;

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    if (totalPages > 1)
        return (
            <nav className="pagination-wrapper justify-content-end" aria-label="Navigazione allineata a destra">
                <ul className="pagination">
                    <li className="page-item button__indietro">
                        <button className={ indietroDisabled === true ? "page-link disabled" : "page-link" } tabIndex="-1" onClick={ () => paginate(currentPage - 1) }>
                            <span>Indietro</span>
                        </button>
                    </li>
                    { pageNumbers.map(number => (
                        <li key={ number } className="page-item">
                            { number === currentPage ?
                                <button onClick={ () => paginate(number) } tabIndex="-1" className="page-link" aria-current="page">{ number }</button>
                                :
                                <button onClick={ () => paginate(number) } tabIndex="-1" className="page-link">{ number }</button>
                            }
                        </li>
                    )) }
                    <li className="page-item button__avanti">
                        <button className={ avantiDisabled === true ? "page-link disabled" : "page-link" } tabIndex="-1" onClick={ () => paginate(currentPage + 1) }>
                            <span>Avanti</span>
                        </button>
                    </li>
                </ul>
            </nav>
        );
    else
        return (<></>);
};

PaginationComponent.propTypes = {
    currentPage: PropTypes.number.isRequired,
};

PaginationComponent.defaultProps = {
    currentPage: 1,
};

export default PaginationComponent;